import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Number$MIN_SAFE_INTEGER from "@babel/runtime-corejs3/core-js-stable/number/min-safe-integer";
import _Number$MAX_SAFE_INTEGER from "@babel/runtime-corejs3/core-js-stable/number/max-safe-integer";
import Big from 'big.js';
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n\tmax-height:none !important;\n\theight:0 !important;\n\tvisibility:hidden !important;\n  position:absolute !important;\n  overflow:hidden !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing', 'word-break'];
var hiddenTextarea;
export function calculateNodeStyling(node) {
  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(new Big(parseFloat(style.getPropertyValue('padding-bottom')) || 0).plus(parseFloat(style.getPropertyValue('padding-top')) || 0).valueOf());
  var borderSize = parseFloat(new Big(parseFloat(style.getPropertyValue('border-bottom-width')) || 0).plus(parseFloat(style.getPropertyValue('border-top-width')) || 0).valueOf());
  var sizingStyle = _mapInstanceProperty(SIZING_STYLE).call(SIZING_STYLE, function (name) {
    var _context;
    return _concatInstanceProperty(_context = "".concat(name, ":")).call(_context, style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };
  return nodeInfo;
}
export default function calculateNodeHeight(uiTextNode) {
  var _context2;
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tab-index', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    document.body.appendChild(hiddenTextarea);
  }
  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  }
  var _calculateNodeStyling = calculateNodeStyling(uiTextNode),
    paddingSize = _calculateNodeStyling.paddingSize,
    borderSize = _calculateNodeStyling.borderSize,
    boxSizing = _calculateNodeStyling.boxSizing,
    sizingStyle = _calculateNodeStyling.sizingStyle;
  hiddenTextarea.setAttribute('style', _concatInstanceProperty(_context2 = "".concat(sizingStyle, ";")).call(_context2, HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = _Number$MIN_SAFE_INTEGER;
  var maxHeight = _Number$MAX_SAFE_INTEGER;
  var height = parseFloat(new Big(hiddenTextarea.scrollHeight).valueOf());
  if (boxSizing === 'border-box') {
    height = parseFloat(new Big(height).plus(borderSize).valueOf()); // height += borderSize
  } else if (boxSizing === 'content-box') {
    height = parseFloat(new Big(height).minus(paddingSize).valueOf()); // height -= paddingSize
  }

  if (minRows !== null || maxRows !== null) {
    hiddenTextarea.value = ' ';
    var bigSingleRowHeight = new Big(hiddenTextarea.scrollHeight).minus(paddingSize);
    if (minRows !== null) {
      minHeight = parseFloat(bigSingleRowHeight.times(minRows).valueOf());
      if (boxSizing === 'border-box') {
        minHeight = parseFloat(new Big(minHeight).plus(paddingSize).plus(borderSize).valueOf()); // minHeight + paddingSize + borderSize
      }

      height = new Big(minHeight).gt(height) ? minHeight : height; // Math.max(minHeight, height)
    }

    if (maxRows !== null) {
      maxHeight = parseFloat(bigSingleRowHeight.times(maxRows).valueOf());
      if (boxSizing === 'border-box') {
        maxHeight = parseFloat(new Big(maxHeight).plus(paddingSize).plus(borderSize).valueOf()); // maxHeight + paddingSize + borderSize
      }

      height = new Big(maxHeight).lt(height) ? maxHeight : height; //  Math.min(maxHeight, height)
    }
  }

  var overflowY = new Big(height).lt(maxHeight) ? 'hidden' : '';
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowY: overflowY
  };
}